import { BFF_API_ROUTES } from 'constants/routes';

import { baseRTKApi } from 'shared/api/baseApi';
import type {
  TSlots,
  TUpdateDeliveryAddressParams,
  TSelectSlotsParams,
  TConfirmationRequestParams,
  TConfirmationSubmitParams,
  TConfirmationSubmit,
  TIframe,
  TConfirmationRequestClientResponse,
} from 'shared/types/TDelivery';

export const preApprovals = baseRTKApi.injectEndpoints({
  endpoints: (build) => ({
    getDeliverySlots: build.mutation<TSlots, { offerId: string }>({
      query: (params) => ({
        url: BFF_API_ROUTES.getDeliverySlots,
        method: 'GET',
        params,
      }),
    }),
    updateDeliveryAddress: build.mutation<null, TUpdateDeliveryAddressParams>({
      query: (query) => ({
        url: BFF_API_ROUTES.updateDeliveryAddress,
        method: 'POST',
        body: query,
      }),
    }),
    selectDeliverySlot: build.mutation<null, TSelectSlotsParams>({
      query: (query) => ({
        url: BFF_API_ROUTES.selectDeliverySlot,
        method: 'POST',
        body: query,
      }),
    }),
    confirmationRequestDelivery: build.mutation<TConfirmationRequestClientResponse, TConfirmationRequestParams>({
      query: (query) => ({
        url: BFF_API_ROUTES.confirmationRequestDelivery,
        method: 'POST',
        body: query,
      }),
    }),
    confirmationSubmitDelivery: build.mutation<TConfirmationSubmit & { statusCode: number }, TConfirmationSubmitParams>(
      {
        query: (query) => ({
          url: BFF_API_ROUTES.confirmationSubmitDelivery,
          method: 'POST',
          body: query,
        }),
        transformResponse: (data: TConfirmationSubmit) => {
          return {
            verified: data.verified,
            statusCode: 200,
          };
        },
        transformErrorResponse: (error) => {
          return {
            verified: false,
            statusCode: error?.status || 500,
          };
        },
      },
    ),
    getIframeInfo: build.mutation<TIframe, { offerId: string }>({
      query: (params) => ({
        url: BFF_API_ROUTES.getIframeInfo,
        method: 'GET',
        params,
      }),
    }),
  }),
});

export const {
  useGetDeliverySlotsMutation,
  useUpdateDeliveryAddressMutation,
  useSelectDeliverySlotMutation,
  useConfirmationRequestDeliveryMutation,
  useConfirmationSubmitDeliveryMutation,
  useGetIframeInfoMutation,
} = preApprovals;
